import { render, staticRenderFns } from "./EipPaginationSteps.vue?vue&type=template&id=b8165016&"
import script from "./EipPaginationSteps.vue?vue&type=script&lang=js&"
export * from "./EipPaginationSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports